import React from "react";

export interface ImageProps extends React.ComponentPropsWithRef<"img"> {
  src?: string;
  alt?: string;
  onLoad?: (event: React.SyntheticEvent<HTMLImageElement, Event>) => void;
}

const Image: React.FC<ImageProps> = React.forwardRef(
  ({ src, alt, onLoad, ...props }, ref) => {
    if (!src) return null;

    return (
      <img
        loading="lazy"
        ref={ref}
        {...props}
        src={src}
        alt={alt}
        {...(onLoad && { onLoad: onLoad })}
      />
    );
  }
);

Image.defaultProps = {};

export { Image };
